export enum groupMembershipRoles {
  MEMBER = 'member',
  APPLIED = 'applied',
  INACTIVE = 'inactive',
  APPLICATIONREMOVED = 'application_removed',
  INDIRECT = 'indirect',
  DIRECT = 'direct',
};
